export const defaultInput = `(0, 1441792) {Character { char: 120, font: "cmr10" }}
(0, 2228224) {Character { char: 120, font: "cmr10" }}
(0, 3014656) {Character { char: 120, font: "cmr10" }}
(0, 3801088) {Character { char: 120, font: "cmr10" }}
(0, 4587520) {Character { char: 120, font: "cmr10" }}
(0, 5373952) {Character { char: 120, font: "cmr10" }}
(0, 6160384) {Character { char: 120, font: "cmr10" }}
(0, 655360) {Character { char: 120, font: "cmr10" }}
(10017646, 1441792) {Character { char: 120, font: "cmr10" }}
(10017646, 5373952) {Character { char: 120, font: "cmr10" }}
(10158080, 4587520) {Character { char: 120, font: "cmr10" }}
(10158080, 655360) {Character { char: 120, font: "cmr10" }}
(10267307, 2228224) {Character { char: 120, font: "cmr10" }}
(10267307, 3014656) {Character { char: 120, font: "cmr10" }}
(10267307, 3801088) {Character { char: 120, font: "cmr10" }}
(11328366, 1441792) {Character { char: 120, font: "cmr10" }}
(11328366, 5373952) {Character { char: 120, font: "cmr10" }}
(11468800, 4587520) {Character { char: 120, font: "cmr10" }}
(11468800, 655360) {Character { char: 120, font: "cmr10" }}
(11578027, 3014656) {Character { char: 120, font: "cmr10" }}
(12124160, 2228224) {Character { char: 120, font: "cmr10" }}
(12124160, 3801088) {Character { char: 120, font: "cmr10" }}
(12779520, 4587520) {Character { char: 120, font: "cmr10" }}
(12779520, 655360) {Character { char: 120, font: "cmr10" }}
(12919954, 1441792) {Character { char: 120, font: "cmr10" }}
(12919954, 5373952) {Character { char: 120, font: "cmr10" }}
(1310720, 2228224) {Character { char: 120, font: "cmr10" }}
(1310720, 3014656) {Character { char: 120, font: "cmr10" }}
(1310720, 3801088) {Character { char: 120, font: "cmr10" }}
(1310720, 6160384) {Character { char: 120, font: "cmr10" }}
(13434880, 3014656) {Character { char: 120, font: "cmr10" }}
(13434880, 3801088) {Character { char: 120, font: "cmr10" }}
(13981013, 2228224) {Character { char: 120, font: "cmr10" }}
(14230674, 1441792) {Character { char: 120, font: "cmr10" }}
(14230674, 5373952) {Character { char: 120, font: "cmr10" }}
(14417920, 4587520) {Character { char: 120, font: "cmr10" }}
(14417920, 655360) {Character { char: 120, font: "cmr10" }}
(15291733, 2228224) {Character { char: 120, font: "cmr10" }}
(15291733, 3014656) {Character { char: 120, font: "cmr10" }}
(15291733, 3801088) {Character { char: 120, font: "cmr10" }}
(15728640, 4587520) {Character { char: 120, font: "cmr10" }}
(15728640, 655360) {Character { char: 120, font: "cmr10" }}
(15822263, 1441792) {Character { char: 120, font: "cmr10" }}
(15822263, 5373952) {Character { char: 120, font: "cmr10" }}
(1591589, 1441792) {Character { char: 120, font: "cmr10" }}
(1591589, 5373952) {Character { char: 120, font: "cmr10" }}
(1638400, 4587520) {Character { char: 120, font: "cmr10" }}
(1638400, 655360) {Character { char: 120, font: "cmr10" }}
(16602453, 2228224) {Character { char: 120, font: "cmr10" }}
(16602453, 3014656) {Character { char: 120, font: "cmr10" }}
(16602453, 3801088) {Character { char: 120, font: "cmr10" }}
(17039360, 4587520) {Character { char: 120, font: "cmr10" }}
(17039360, 655360) {Character { char: 120, font: "cmr10" }}
(17132983, 1441792) {Character { char: 120, font: "cmr10" }}
(17132983, 5373952) {Character { char: 120, font: "cmr10" }}
(17913173, 2228224) {Character { char: 120, font: "cmr10" }}
(17913173, 3014656) {Character { char: 120, font: "cmr10" }}
(17913173, 3801088) {Character { char: 120, font: "cmr10" }}
(18443703, 1441792) {Character { char: 120, font: "cmr10" }}
(18443703, 5373952) {Character { char: 120, font: "cmr10" }}
(18677760, 4587520) {Character { char: 120, font: "cmr10" }}
(18677760, 655360) {Character { char: 120, font: "cmr10" }}
(19223893, 3801088) {Character { char: 120, font: "cmr10" }}
(19770027, 2228224) {Character { char: 120, font: "cmr10" }}
(19770027, 3014656) {Character { char: 120, font: "cmr10" }}
(19988480, 4587520) {Character { char: 120, font: "cmr10" }}
(19988480, 655360) {Character { char: 120, font: "cmr10" }}
(20035291, 1441792) {Character { char: 120, font: "cmr10" }}
(20035291, 5373952) {Character { char: 120, font: "cmr10" }}
(21080747, 2228224) {Character { char: 120, font: "cmr10" }}
(21080747, 3801088) {Character { char: 120, font: "cmr10" }}
(21346011, 1441792) {Character { char: 120, font: "cmr10" }}
(21346011, 5373952) {Character { char: 120, font: "cmr10" }}
(21626880, 3014656) {Character { char: 120, font: "cmr10" }}
(21626880, 4587520) {Character { char: 120, font: "cmr10" }}
(21626880, 655360) {Character { char: 120, font: "cmr10" }}
(22656731, 1441792) {Character { char: 120, font: "cmr10" }}
(22656731, 5373952) {Character { char: 120, font: "cmr10" }}
(22937600, 2228224) {Character { char: 120, font: "cmr10" }}
(22937600, 3014656) {Character { char: 120, font: "cmr10" }}
(22937600, 3801088) {Character { char: 120, font: "cmr10" }}
(22937600, 4587520) {Character { char: 120, font: "cmr10" }}
(22937600, 655360) {Character { char: 120, font: "cmr10" }}
(24248320, 1441792) {Character { char: 120, font: "cmr10" }}
(24248320, 2228224) {Character { char: 120, font: "cmr10" }}
(24248320, 3014656) {Character { char: 120, font: "cmr10" }}
(24248320, 3801088) {Character { char: 120, font: "cmr10" }}
(24248320, 4587520) {Character { char: 120, font: "cmr10" }}
(24248320, 5373952) {Character { char: 120, font: "cmr10" }}
(24248320, 655360) {Character { char: 120, font: "cmr10" }}
(25559040, 1441792) {Character { char: 120, font: "cmr10" }}
(25559040, 2228224) {Character { char: 120, font: "cmr10" }}
(25559040, 3014656) {Character { char: 120, font: "cmr10" }}
(25559040, 3801088) {Character { char: 120, font: "cmr10" }}
(25559040, 4587520) {Character { char: 120, font: "cmr10" }}
(25559040, 5373952) {Character { char: 120, font: "cmr10" }}
(25559040, 655360) {Character { char: 120, font: "cmr10" }}
(2621440, 2228224) {Character { char: 120, font: "cmr10" }}
(2621440, 3014656) {Character { char: 120, font: "cmr10" }}
(2621440, 6160384) {Character { char: 120, font: "cmr10" }}
(2902309, 1441792) {Character { char: 120, font: "cmr10" }}
(2902309, 5373952) {Character { char: 120, font: "cmr10" }}
(2949120, 4587520) {Character { char: 120, font: "cmr10" }}
(2949120, 655360) {Character { char: 120, font: "cmr10" }}
(3167573, 3801088) {Character { char: 120, font: "cmr10" }}
(3932160, 2228224) {Character { char: 120, font: "cmr10" }}
(3932160, 6160384) {Character { char: 120, font: "cmr10" }}
(4213029, 1441792) {Character { char: 120, font: "cmr10" }}
(4213029, 5373952) {Character { char: 120, font: "cmr10" }}
(4259840, 4587520) {Character { char: 120, font: "cmr10" }}
(4259840, 655360) {Character { char: 120, font: "cmr10" }}
(4478293, 3014656) {Character { char: 120, font: "cmr10" }}
(4478293, 3801088) {Character { char: 120, font: "cmr10" }}
(5461333, 6160384) {Character { char: 120, font: "cmr10" }}
(5570560, 4587520) {Character { char: 120, font: "cmr10" }}
(5570560, 655360) {Character { char: 120, font: "cmr10" }}
(5789013, 2228224) {Character { char: 120, font: "cmr10" }}
(5789013, 3014656) {Character { char: 120, font: "cmr10" }}
(5789013, 3801088) {Character { char: 120, font: "cmr10" }}
(5804617, 1441792) {Character { char: 120, font: "cmr10" }}
(5804617, 5373952) {Character { char: 120, font: "cmr10" }}
(6990506, 6160384) {Character { char: 120, font: "cmr10" }}
(7208960, 4587520) {Character { char: 120, font: "cmr10" }}
(7208960, 655360) {Character { char: 120, font: "cmr10" }}
(7396206, 1441792) {Character { char: 120, font: "cmr10" }}
(7396206, 5373952) {Character { char: 120, font: "cmr10" }}
(7645867, 2228224) {Character { char: 120, font: "cmr10" }}
(7645867, 3014656) {Character { char: 120, font: "cmr10" }}
(7645867, 3801088) {Character { char: 120, font: "cmr10" }}
(8301226, 6160384) {Character { char: 120, font: "cmr10" }}
(8519680, 4587520) {Character { char: 120, font: "cmr10" }}
(8519680, 655360) {Character { char: 120, font: "cmr10" }}
(8706926, 1441792) {Character { char: 120, font: "cmr10" }}
(8706926, 5373952) {Character { char: 120, font: "cmr10" }}
(8956587, 2228224) {Character { char: 120, font: "cmr10" }}
(8956587, 3014656) {Character { char: 120, font: "cmr10" }}
(8956587, 3801088) {Character { char: 120, font: "cmr10" }}
(9611946, 6160384) {Character { char: 120, font: "cmr10" }}`;